import { IOrderObject, IPGResponse, IUpdatePayload, IFetchCartParams } from '~api/CartAPI/ICartApiSdk';
import { parseTotals, reduceToCartItems } from '~api/CartAPI/utils/utils';
import {
    HttpMethod,
    IRequestParams,
    getTransId,
    makeRestAPIRequest,
    reduceToCartOrderData
} from '~api/CartRestAPI/utils/utils';

export const fetchRestAPICartItems = async (signal?: AbortSignal, extraParams?: IFetchCartParams) => {
    const params: IRequestParams = {
        signal,
        method: HttpMethod.GET,
        ...extraParams
    };
    const response = await makeRestAPIRequest<IPGResponse<IOrderObject>>(params);
    const cartItems = reduceToCartItems({ response });
    const cartTotals = parseTotals(response);
    const cartOrderData = reduceToCartOrderData({ response });

    return { cartItems, cartTotals, cartOrderData };
};

export const updateRestAPICartItem = async ({
    skus,
    quantity,
    cartId,
    collectionId
}: IUpdatePayload) => {
    const collection =
        cartId && collectionId ? { CART_ID: cartId, COLLECTION_ID: collectionId } : {};
    const skuId = Number(skus[0]);
    const params: IRequestParams = {
        method: HttpMethod.POST,
        transId: getTransId(),
        skuId,
        body: {
            sku_id: skuId,
            qty: quantity,
            ...collection
        }
    };

    if (quantity === 0) {
        params.method = HttpMethod.DELETE;
        params.body = undefined;
    }

    const response = await makeRestAPIRequest<IPGResponse<IOrderObject>>(params);

    return response;
};
